module.exports = __webpack_public_path__ + "static/media/logo_tec5.b83a23d2.png";